export default 
`Hello! My name is Hugo, Alex's Application Assistent System.
How may I help you?
Please Enter: "cv", "contact", "hobbies", "languages" or "more"`